import { createGlobalStyle } from 'styled-components';
/* stylelint-disable */
const GlobalStyle = createGlobalStyle`
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
main {
  display: block;
}

body {
  line-height: 120%;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote::before,
blockquote::after,
q::before,
q::after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

html {
  box-sizing: border-box;
  font-size: 62.5%;

  @media screen and (max-width: 1240px) {
    font-size: 55%;
  }

  @media screen and (max-width: 1024px) {
    font-size: 50%;
  }

 
  @media print {
    font-size: 35%;
  }

  /* 
    1240px -> font-size: 55%;
    1024px -> font-size: 50%;
  */
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

html {
  font-size: 62.5%;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  font-family: 'Circular', 'Helvetica', 'Myriad', 'Sans-Serif';
  touch-action: manipulation;

  @media screen and (max-width: 1240px) {
    font-size: 55%;
  }

  @media screen and (max-width: 1024px) {
    font-size: 50%;
  }
 
  @media print {
    font-size: 35%;
  }

}

body {
  font-family: 'Circular', 'Helvetica', 'Myriad', sans-serif;
  font-size: 1.6rem;
  touch-action: manipulation;

  &::-webkit-scrollbar {
    display: none;
  }
}

input, button {
  font-family: 'Circular', 'Helvetica', 'Myriad', sans-serif;
}

* {
  touch-action: manipulation;
}

.grecaptcha-badge {
  display: none !important;
}

.modal-full-width {
  > div{
    width: 100%
  }
}

`;

export default GlobalStyle;
